var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"guideline-box"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.moveLinkFlag),expression:"$store.state.moveLinkFlag"}],staticClass:"guide-dash",style:(`top:${_vm.$store.state.dashPosTop}px;
        left:${_vm.$store.state.dashPosLeft}px;
        height: ${_vm.$store.state.dashHeight}px;
        transform: rotate(${_vm.$store.state.dashDeg}deg);
        border-color:blue`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }